/**
 * Detect visitor country from Netlify geo context (via serverless function).
 * Falls back to null when unavailable (e.g. offline dev without Netlify).
 */
export async function detectCountry() {
  try {
    const res = await fetch('/.netlify/functions/detect-country');
    if (!res.ok) return null;
    const data = await res.json();
    return data.country ?? null;
  } catch {
    return null;
  }
}
